import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { motion } from 'framer-motion';
import ClientManagement from './ClientManagement';
import { UserModel } from '../../../models/UserModel';
import { Typography } from 'antd';
import RestrictedAccessModal  from './ModalForPronotValidated';

const { Text } = Typography;
export interface BillingClientSelection {
  id: string;
  name: string;
  email: string;
}

interface BillingClientModalProps {
  show: boolean;
  onHide: () => void;
  onClientConfirm: (client: BillingClientSelection) => void;
}

const BillingClientModal: React.FC<BillingClientModalProps> = ({
  show,
  onHide,
  onClientConfirm
}) => {

  const [currentUser, setCurrentUser] = useState<UserModel | null>(null);

  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail");
    const storedValidation = localStorage.getItem("isvalidated"); 

    if (storedEmail) {
      setCurrentUser({
        email: storedEmail,
        is_validated: storedValidation === "true" 
      } as UserModel);
    }
  }, []);

  if (currentUser && currentUser.is_validated === false) {
    return (
      <RestrictedAccessModal
        show={show}
        onHide={onHide}
      />
    );
  }

  const handleClientSelect = (client: any) => {
    const clientData: BillingClientSelection = {
      id: client.id?.toString() || '',
      name: `${client.firstname || ''} ${client.name || ''}`.trim() || client.name || 'Client sans nom',
      email: client.email || ''
    };
    onClientConfirm(clientData);
  };

  return (
    <Modal
      title="Sélection du client pour facturation"
      open={show}
      onCancel={onHide}
      footer={null}
      width={900}
      className="billing-client-modal"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
      >
        <p style={{ marginBottom: "16px", color: "#666" }}>
          Sélectionnez le client auquel vous souhaitez envoyer la facturation de cette annonce.
        </p>

        <ClientManagement
          selectMode={true}
          onClientSelect={handleClientSelect}
          onClose={onHide}
        />
      </motion.div>
    </Modal>
  );
};

export default BillingClientModal;
